import Immutable from 'immutable';
import {
  CLEAR_EXCESS_BAGGAGES,
  FLAG_GETTING_EXCESS_BAGGAGES,
  GET_EXCESS_BAGGAGES,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_EXCESS_BAGGAGES:
      return state.setIn(['all', 'loading'], payload);
    case GET_EXCESS_BAGGAGES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_EXCESS_BAGGAGES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
